export const formatNumberWithCommasAnd2Decimals = (value: string): string => {
  if (value === undefined || value === null) return '';
  const regex = /^-?\d+(\.\d{1,2})?$/;
  let isNegative = false;

  if (value.startsWith('-')) {
    isNegative = true;
    value = value.slice(1);
  }

  if (regex.test(value)) {
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formattedValue = parts.join('.');
    return isNegative ? `-${formattedValue}` : formattedValue;
  }

  let numericValue = value.replace(/(?!^-)[^\d.]/g, '');

  const firstDotIndex = numericValue.indexOf('.');

  if (firstDotIndex !== -1) {
    numericValue = numericValue.replace(/\./g, '');
    numericValue =
      numericValue.slice(0, firstDotIndex) +
      '.' +
      numericValue.slice(firstDotIndex);
  }

  const parts = numericValue.split('.');

  if (parts[1] && parts[1].length > 2) {
    parts[1] = parts[1].slice(0, 2);
  }

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const formattedValue = parts.join('.');
  return isNegative ? `-${formattedValue}` : formattedValue;
};

export const formatPercentageInput = (value: string): string => {
  let numericValue = value.replace(/[^\d.]/g, '');

  const firstDotIndex = numericValue.indexOf('.');

  if (firstDotIndex !== -1) {
    numericValue = numericValue.replace(/\./g, '');
    numericValue =
      numericValue.slice(0, firstDotIndex) +
      '.' +
      numericValue.slice(firstDotIndex);
  }

  const parts = numericValue.split('.');

  if (parts[1] && parts[1].length > 2) {
    parts[1] = parts[1].slice(0, 2);
  }

  if (parts[0] && parts[0].length > 2 && Number(parts[0]) >= 100) {
    if (Number(parts[0]) === 100) return parts[0];
    parts[0] = parts[0].slice(0, 2);
  }

  const formattedValue = parts.join('.');
  return formattedValue;
};
